import { BetOrderCloseReason } from '@/constants';
import { createSimpleDictionary } from '@/stores/utils/createSimpleDictionary';

export const betOrderCloseReasonDictionary = createSimpleDictionary([
    { id: BetOrderCloseReason.Normally, name: 'dictionaries.closeReasonNormally' },
    { id: BetOrderCloseReason.ScoreChanged, name: 'dictionaries.closeReasonScoreChanged' },
    { id: BetOrderCloseReason.TimedOut, name: 'dictionaries.closeReasonTimedOut' },
    { id: BetOrderCloseReason.InsufficientCredit, name: 'dictionaries.closeReasonInsufficientCredit' },
    { id: BetOrderCloseReason.GameFinished, name: 'dictionaries.closeReasonGameFinished' },
    { id: BetOrderCloseReason.ManuallyClosed, name: 'dictionaries.closeReasonManuallyClosed' },
    { id: BetOrderCloseReason.GameStarted, name: 'dictionaries.closeReasonGameStarted' },
    { id: BetOrderCloseReason.RejectedBet, name: 'dictionaries.closeReasonGameRejectedBet' },
    { id: BetOrderCloseReason.AccountBlocked, name: 'dictionaries.closeReasonGameAccountBlocked' },
]);
